import { getRedirectContext } from '@frontend/web/utils/routing/getRedirectContext';
import type { ParsedLocation } from '@tanstack/react-router';
import type { RouterContext } from '../../routes/__root';
import { redirect } from '../router';
import { getOnboardingCompleteRedirect, getOnboardingRedirect, getRedirectDecision } from './redirectPolicy';

export const handleRedirectBeforeLoad = ({
  context,
  location,
}: {
  context: RouterContext;
  location: ParsedLocation;
}) => {
  const redirectContext = getRedirectContext({ context, location });
  const redirectDecision = getRedirectDecision(redirectContext);

  if (redirectDecision.action === 'redirect') {
    throw redirect({
      search: redirectDecision.search,
      to: redirectDecision.to,
    });
  }

  if (redirectDecision.action !== 'allow') {
    return;
  }

  const onboardingDecision = getOnboardingRedirect({
    description: redirectContext.description,
    membershipComplete: redirectContext.membershipComplete,
    pathname: redirectContext.pathname,
    profileComplete: redirectContext.profileComplete,
    promo: redirectContext.promo,
  });

  if (onboardingDecision.action === 'redirect') {
    throw redirect({
      search: onboardingDecision.search,
      to: onboardingDecision.to,
    });
  }
};

export const handleOnboardingCompleteBeforeLoad = ({
  context,
  location,
}: {
  context: RouterContext;
  location: ParsedLocation;
}) => {
  const decision = getOnboardingCompleteRedirect(getRedirectContext({ context, location }));

  if (decision.action === 'redirect') {
    throw redirect({ to: decision.to });
  }
};
